import { createContext, useContext } from "react";
import { Brand } from "../models/brand";

export const BrandContext = createContext<Brand | undefined>(undefined);

export function useBrandContext() {
  const context = useContext(BrandContext);
  return context;
}
